import { projectClient } from '../../client/client';

export const role = {
  list: projectClient('/iam/role').get,
  create: projectClient('/iam/role').post,
  get: projectClient('/iam/role/{roleId}').get,
  delete: projectClient('/iam/role/{roleId}').delete,
  update: projectClient('/iam/role/{roleId}').patch,
};
